<div class="modal-header">
  <h5 class="modal-title" i18n="@@InvoiceSettingsHeader">Rechnungseinstellungen</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="formService.form" (ngSubmit)="patchAndClose()" *ngIf="formReady">
    <div class="footnotes">
      <div class="form-group mb-2">
        <label for="vatId" i18n="@@InvoiceSettingsVatId">Steuernummer/Umsatzssteuer-ID.*</label>
        <input type="text" class="form-control" id="vatId" formControlName="vatId" (change)="refresh()" />
        <div class="error">
          <em *ngIf="formService.validateControl('vatId')" i18n="@@InvoiceSettingsVatIdError">
            Steuernummer/Umsatzssteuer-ID wird benötigt
          </em>
        </div>
      </div>

      <div class="form-group mb-2">
        <label for="ceo"i18n="@@InvoiceSettingsCeo">Geschäftsführer</label>
        <input type="text" class="form-control" id="ceo" formControlName="ceo" (change)="refresh()" />
        <!-- <div class="error">
          <em *ngIf="formService.validateControl('ceo')" i18n="@@InvoiceSettingsCeoError">
            Geschäftsführer wird benötigt
          </em>
        </div> -->
      </div>
      
      <div class="form-group mb-2">
        <label for="commercialRegister" i18n="@@InvoiceSettingsCommercialRegister">Handelsregister</label>
        <input type="text" class="form-control" id="commercialRegister" formControlName="commercialRegister" (change)="refresh()" />
        <!-- <div class="error">
          <em *ngIf="formService.validateControl('commercialRegister')" i18n="@@InvoiceSettingsCommercialRegisterError">
            Handelsregister wird benötigt
          </em>
        </div> -->
      </div>
      
      <div class="form-group mb-2">
        <label for="commercialRegisterId" i18n="@@InvoiceSettingsCommercialRegisterId">Handelsregisternummer</label>
        <input type="text" class="form-control" id="commercialRegisterId" formControlName="commercialRegisterId" (change)="refresh()" />
        <!-- <div class="error">
          <em *ngIf="formService.validateControl('commercialRegister')" i18n="@@InvoiceSettingsCommercialRegisterIdError">
            Handelsregisternummer wird benötigt
          </em>
        </div> -->
      </div>

      <div class="form-group iban mb-2">
        <label for="iban" i18n="@@InvoiceSettingsIban">IBAN</label>
        <input type="text" class="form-control" id="iban" formControlName="iban" (change)="validateIBAN()" />
        <!-- <div class="error">
          <em *ngIf="formService.validateControl('iban')" i18n="@@InvoiceSettingsIbanError">
            IBAN wird benötigt
          </em>
        </div> -->
      </div>

      <div class="form-group mb-2 bank">
        <label for="bank" i18n="@@InvoiceSettingsBank">Bank</label>
        <input type="text" class="form-control" id="bank" formControlName="bank" (change)="refresh()" />
        <!-- <div class="error">
          <em *ngIf="formService.validateControl('bank')" i18n="@@InvoiceSettingsBankError">
            Bank wird benötigt
          </em>
        </div> -->
      </div>

      <div class="form-group mb-2 bic">
        <label for="bic" i18n="@@InvoiceSettingsBic">BIC</label>
        <input type="text" class="form-control" id="bic" formControlName="bic" (change)="refresh()" />
        <!-- <div class="error">
          <em *ngIf="formService.validateControl('bic')" i18n="@@InvoiceSettingsBicError">
            BIC wird benötigt
          </em>
        </div> -->
      </div>
      
      <p>Die Addressdaten entsprechen den Angaben im <a class="link" (click)="moveToAccount()">Konto</a>.</p>
    </div>

    <div class="stationary">
      <div class="form-group mb-2 letterheadHeight">
        <label for="letterheadHeight" i18n="@@LetterheadHeightLabel">Briefkopf</label>
        <input type="number" id="letterheadHeight" class="form-control" formControlName="letterheadHeight" (focus)="highlightHeader(true)" (blur)="highlightHeader(false)" (change)="refresh()" />
        <input type="text" placeholder="mm" i18n-placeholder="@@MilimeterUnit" class="form-control" disabled />
      </div>
  
      <div class="form-group mb-2 footnoteHeight">
        <label for="footnoteHeight">Fußzeile</label>
        <input type="number" min="14" id="footnoteHeight" class="form-control" formControlName="footnoteHeight" (focus)="highlightFooter(true)" (blur)="highlightFooter(false)" (change)="refresh()" />
        <input type="text" placeholder="mm" i18n-placeholder="@@MilimeterUnit" class="form-control" disabled />
      </div>

      <div class="form-group mb-2 isUsingFootnote" >
        <label for="isUsingFootnote" i18n="@@IsUsingFootnoteLabel">
          <input type="checkbox" id="isUsingFootnote" class="form-check-input" formControlName="isUsingFootnote" (change)="refresh()" />
          Rechnungsdetails und Bankverbindung in der Fußzeile einblenden
        </label>
      </div>

      <div class="form-group mb-2 customStationary">
        <img *ngIf="filePreview || customStationary" [src]="filePreview || customStationary" alt="Briefpapier" i18n="@@IsUsingStationeryLabel">
        <label for="isUsingStationery" i18n="@@IsUsingStationeryLabel">
          <input type="checkbox" id="isUsingStationery" class="form-check-input mb-2"
            formControlName="isUsingStationery" (change)="refresh()" />
          Briefpapier nutzen
        </label>
        <input
          type="file" id="customStationary" class="form-control"
          label=""
          accept="image/png, image/jpg, image/jpeg"
          (change)="setCustomStationary($event)"
          ngbTooltip="Wählen Sie eine JPG-Datei im DIN A4 Format aus (ideal sind 3508 × 2480 Pixel)" 
          i18n-ngbTooltip="@@SetCustomStationaryTooltip"/>
        <button type="button" class="btn mt-2" style="grid-column: 2;"
          (click)="downloadPreview()" i18n="@@DownloadPreviewButton">
          Beispiel herunterladen
        </button>
      </div>
    </div>
  </form>

  <!-- <div class="preview" [class]="(isHeaderHighlighted ? 'highlightHeader' : '') + (isFooterHighlighted ? ' highlightFooter' : '')">
    <app-invoice-pdf *ngIf="invoiceExample && invoiceSettings"
      [example]="invoiceExample"
      [exampleSettings]="invoiceSettings"
      [stationaryPreview]="filePreview">
    </app-invoice-pdf>
  </div> -->
</div>

<div class="modal-footer">
  <div class="float-end">
    <button type="button" class="btn btn-yellow text-white me-2" data-bs-dismiss="modal" (click)="close()" i18n="@@CancelButton">
      Abbrechen
    </button>
    <button type="button" class="btn btn-save" data-bs-dismiss="modal" (click)="patchAndClose()" i18n="@@SaveButton">
      Änderungen speichern
    </button>
  </div>
</div>
